// ═══════════════════════════════════════════════════════════════
// CULTIVATION MEMBERS TAB — All members by engagement
// Path: src/components/cultivation/CultivationMembersTab.jsx
// ═══════════════════════════════════════════════════════════════

import React from "react";
import { Users, Heart, Star, UserPlus } from "lucide-react";
import { useApp } from "../../context/AppContext";
import { FONT_SIZES, ICON_SIZES } from "../../constants/appConfig";
import { Card } from "../ui/Card";
import { EngagementMeter } from "../../utils/cultivationUtils";

export const CultivationMembersTab = ({ enriched, onMemberClick }) => {
  const { palette, pathways, members } = useApp();

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", width: "100%" }}>
      <Card>
        <h3
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            margin: "0 0 16px",
            fontSize: FONT_SIZES.md,
            fontWeight: 600,
            color: palette.text1,
            paddingBottom: 12,
            borderBottom: `1px solid ${palette.cardBorder}`,
          }}
        >
          <Users size={ICON_SIZES.md} style={{ color: palette.accent1 }} /> All Members by
          Engagement ({members.length})
        </h3>
        {enriched.map((m) => {
          const pw = pathways.find((p) => p.id === m.pathway);
          return (
            <div
              key={m.id}
              onClick={() => onMemberClick(m)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 14px",
                borderRadius: 8,
                cursor: "pointer",
                marginBottom: 4,
                border: `1px solid ${palette.cardBorder}`,
                transition: "all 0.15s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = `${palette.accent1}06`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: 3,
                  background: pw?.color || "#9ca3af",
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span
                    style={{
                      fontSize: FONT_SIZES.sm,
                      fontWeight: 600,
                      color: palette.text1,
                    }}
                  >
                    {m.lastName}, {m.firstName}
                  </span>
                  {m.isDonor && (
                    <Heart size={ICON_SIZES.xs} style={{ color: "#10b981" }} />
                  )}
                  {m.isBoardMember && (
                    <Star size={ICON_SIZES.xs} style={{ color: "#f59e0b" }} />
                  )}
                  {m.pathway === "prospect" && (
                    <UserPlus size={ICON_SIZES.xs} style={{ color: "#ea580c" }} />
                  )}
                </div>
                {m.organization && (
                  <div
                    style={{
                      fontSize: FONT_SIZES.xs,
                      color: palette.text3,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {m.organization}
                  </div>
                )}
              </div>
              <div
                style={{
                  fontSize: FONT_SIZES.xs,
                  color: palette.text3,
                  textAlign: "right",
                  flexShrink: 0,
                  minWidth: 80,
                }}
              >
                {m.engagement.totalContacts > 0 ? (
                  <span>
                    {m.engagement.totalContacts} contacts ·{" "}
                    {m.engagement.daysSinceContact}d
                  </span>
                ) : (
                  <span style={{ color: "#ef4444" }}>No contacts</span>
                )}
              </div>
              <div style={{ width: 120, flexShrink: 0 }}>
                <EngagementMeter score={m.engagement.score} palette={palette} />
              </div>
            </div>
          );
        })}
      </Card>
    </div>
  );
};
